export default __webpack_public_path__ + "static/media/web_screen_meetings_fr.1c387775.png";